import { useCallback } from 'react';
import { GridRenderEditCellParams } from '@rossum/ui/x-data-grid-pro';
import { DateTimePicker } from '@rossum/ui/x-date-pickers-pro';
import { DATE_CELL_FORMAT } from './dateUtils';

export const DateEditCell = ({
  id,
  field,
  value,
  api,
}: GridRenderEditCellParams) => {
  const wallClock = value instanceof Date ? value : null;

  const handleChange = useCallback(
    (next: Date | null) => {
      api.setEditCellValue({
        id,
        field,
        value: next && !Number.isNaN(next.getTime()) ? next : null,
      });
    },
    [api, id, field]
  );

  return (
    <DateTimePicker
      value={wallClock}
      onChange={handleChange}
      format={DATE_CELL_FORMAT}
      slotProps={{
        textField: {
          autoFocus: true,
          fullWidth: true,
          size: 'small',
          variant: 'standard',
          inputProps: { sx: { pl: 1.25 } },
          InputProps: { sx: { pr: 1.25, fontSize: 'inherit' } },
        },
        openPickerButton: { size: 'small', edge: 'end', sx: { p: 0.25 } },
      }}
    />
  );
};
